import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout pai das rotas /dashboard/mensagens/* — só repassa o Outlet
 * para as filhas (index = lista, thread = conversa).
 */
export const Route = createFileRoute('/dashboard/mensagens')({ component: () => <Outlet /> });
